import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelPreisServiceConfig = {
  name: "ArtikelPreis",
  annotations: []
} as ServiceConfig;